import React, { useRef, useState } from "react";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";

import {
  AvatarFemaleIcon,
  AvatarMaleIcon,
  UserMenuArrow,
} from "@/components/assets/icons";
import { ShowWhen } from "@/components/common";
import { useOutsideClickDetector } from "@/hooks/useOutsideClickDetector";
import { Logout } from "./";
import { useGetInterfaceLanguageRequest } from "@/api/useGetInterfaceLanguageRequest";
import { displayFullName } from "@/utils/fullName.util";
import useGetMainInfoDataRequest from "@/api/useGetMainInfoDataRequest";

const menuList = [
  {
    label: "edit_profile",
    route: "/profile/personal-information",
  },
  {
    label: "security_and_privacy",
    route: "/profile/security",
  },
  {
    label: "transactions",
    route: "/transaction-history",
  },
];

const UserMenu = () => {
  const router = useRouter();
  const t = useTranslations();

  const [isOpened, setIsOpened] = useState(false);
  const userMenuRef = useRef(null);

  const { data: languageData } = useGetInterfaceLanguageRequest();

  const selectedLang = languageData?.data?.data?.lang;

  const { data: mainInfoData } = useGetMainInfoDataRequest();

  const mainInfo = mainInfoData?.data?.data;

  const handleToggle = () => setIsOpened((prev) => !prev);

  useOutsideClickDetector(userMenuRef, () => {
    setIsOpened(false);
  });

  const handleLogout = () => router.push("/log-in");

  const fullName = displayFullName({ selectedLang, mainInfo });

  return (
    <div ref={userMenuRef} className="relative h-[50px]">
      <div
        className="flex min-w-[150px] cursor-pointer gap-2"
        onClick={handleToggle}
      >
        {mainInfo?.sex === false ? <AvatarFemaleIcon /> : <AvatarMaleIcon />}
        <div>
          <p className="min-h-[20px] text-base font-medium">{fullName}</p>
          <div className="flex items-center">
            <p className="mb-0 text-sm font-normal text-[#7D7D7D]">
              {mainInfo?.cardId || ""}
            </p>
            <div>
              <UserMenuArrow className="cursor-pointer" />
            </div>
          </div>
        </div>
      </div>
      <ShowWhen condition={isOpened}>
        <div className="absolute right-0 top-[60px]">
          <div className="w-[222px] rounded-[14px] bg-white shadow">
            <ul className="w-full pl-5">
              {menuList.map((item, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setIsOpened((prev) => !prev);
                    router.push(item.route);
                  }}
                  className="w-full cursor-pointer border-b pb-[10px] pt-4 text-sm font-normal"
                >
                  <ShowWhen condition={!!item.route} elseRender={item.label}>
                    <span className="w-full">{t(item.label)}</span>
                  </ShowWhen>
                </li>
              ))}
            </ul>
            <div onClick={handleLogout} className="p-[10px]">
              <Logout />
            </div>
          </div>
        </div>
      </ShowWhen>
    </div>
  );
};

export { UserMenu };
